import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/layout/Layout'

Vue.use(Router)

export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '首页', icon: 'home' }
    }]
  }
]

export const asyncRouterMap = [
  {
    name: 'cloud',
    meta: {
      title: '设备管理',
    },
    path: '/cloud',
    component: Layout,
    children: [
      {
        name: 'device',
        meta: {
          title: '设备管理',
        },
        path: 'device',
        component: () => import('@/views/cloud/device/index'),
      },
    ]
  },
  {
    name: 'event',
    meta: {
      title: '活动',
    },
    path: '/event',
    component: Layout,
    children: [
      {
        name: 'event',
        meta: {
          title: '活动',
        },
        path: 'event',
        component: () => import('@/views/event/event/index'),
      },
    ]
  },
  {
    name: 'app',
    meta: {
      title: '版本管理',
    },
    path: '/app',
    component: Layout,
    children: [
      {
        path: 'lab',
        name: 'lab',
        component: () => import('@/views/app/lab/index'),
        meta: {
          title: '实验室管理',
        },
      },
      {
        name: 'config',
        meta: {
          title: '配置管理',
        },
        path: 'config',
        component: () => import('@/views/app/config/index'),
      },
    ]
  },
  {
    name: 'account',
    meta: {
      title: '银行管理',
    },
    path: '/account',
    component: Layout,
    children: [
      {
        path: 'accountCode',
        name: 'accountCode',
        component: () => import('@/views/account/code/index'),
        meta: {
          title: '支付码管理',
        },
      },
      {
        path: 'bank',
        name: 'bank',
        component: () => import('@/views/account/bank/index'),
        meta: {
          title: '银行卡管理',
        },
      },
      {
        path: 'bankOperate',
        name: 'bankOperate',
        component: () => import('@/views/account/bankOperate/index'),
        meta: {
          title: '银行卡操作',
        },
      },
      {
        path: 'bankInfo',
        name: 'bankInfo',
        component: () => import('@/views/account/bankInfo/index'),
        meta: {
          title: '银行卡信息管理',
        },
      },
      {
        path: 'smsRegex',
        name: 'smsRegex',
        component: () => import('@/views/account/smsRegex/index'),
        meta: {
          title: '短信模版管理',
        },
      },
      {
        path: 'bankCardPriorityGroup',
        name: 'bankCardPriorityGroup',
        component: () => import('@/views/account/bankCardPriorityGroup/index'),
        meta: {
          title: '级距分组管理',
        },
      },
      {
        path: 'bankNoOperate',
        name: 'bankNoOperate',
        component: () => import('@/views/account/bankNoOperate/index'),
        meta: {
          title: '待分配银行卡',
        },
      },
    ]
  },
  {
    name: 'seller',
    meta: {
      title: '商户项目管理',
    },
    path: '/seller',
    component: Layout,
    children: [
      {
        path: 'project',
        name: 'project',
        component: () => import('@/views/seller/project/index'),
        meta: {
          title: '商户项目管理',
        },
      },
      {
        path: 'balanceChange',
        name: 'balanceChange',
        component: () => import('@/views/seller/balanceChange/index'),
        meta: {
          title: '帐变明细',
        },
      },
    ]
  },
  {
    name: 'profile',
    meta: {
      title: '个人信息管理',
    },
    path: '/profile',
    component: Layout,
    children: [
      {
        path: 'my',
        name: 'my',
        component: () => import('@/views/profile/my/index'),
        meta: {
          title: '个人信息',
        },
      },
      {
        path: 'commissionChange',
        name: 'commissionChange',
        component: () => import('@/views/profile/commissionChange/index'),
        meta: {
          title: '佣金帐变明细',
        },
      },
      {
        path: 'jifenChange',
        name: 'jifenChange',
        component: () => import('@/views/profile/jifenChange/index'),
        meta: {
          title: '积分帐变明细',
        },
      },
    ]
  },
  {
    name: 'permission',
    meta: {
      title: '权限管理',
    },
    path: '/permission',
    component: Layout,
    children: [
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/permission/role/index'),
        meta: {
          title: '后台角色管理',
        },
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/permission/resource/index'),
        meta: {
          title: '资源管理',
        },
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/permission/resourceCategory/index'),
        meta: {
          title: '资源分类管理',
        },
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/permission/menu/index'),
        meta: {
          title: '菜单管理',
        },
      },
    ]
  },
  {
    name: 'withdraw',
    meta: {
      title: '提现管理',
    },
    path: '/withdraw',
    component: Layout,
    children: [
      {
        path: 'withdrawCard',
        name: 'withdrawCard',
        component: () => import('@/views/withdraw/withdrawCard/index'),
        meta: {
          title: '提现卡列表',
        },
      },
      {
        path: 'withdrawRecord',
        name: 'withdrawRecord',
        component: () => import('@/views/withdraw/withdrawRecord/index'),
        meta: {
          title: '提现记录管理',
        },
      },
    ]
  },
  {
    name: 'user',
    meta: {
      title: '用户管理',
    },
    path: '/user',
    component: Layout,
    children: [
      {
        path: 'userGroup',
        name: 'userGroup',
        component: () => import('@/views/user/userGroup/index'),
        meta: {
          title: '用户组',
        },
      },
      {
        path: 'all',
        name: 'all',
        component: () => import('@/views/user/all/index'),
        meta: {
          title: '全部',
        },
      },
      {
        path: 'userAgent',
        name: 'userAgent',
        component: () => import('@/views/user/userAgent/index'),
        meta: {
          title: '代理',
        },
      },
      {
        path: 'userAgentAssistant',
        name: 'userAgentAssistant',
        component: () => import('@/views/user/userAgentAssistant/index'),
        meta: {
          title: '代理助理',
        },
      },
      {
        path: 'userCustomer',
        name: 'userCustomer',
        component: () => import('@/views/user/userCustomer/index'),
        meta: {
          title: '卡主',
        },
      },
      {
        path: 'userManualCustomer',
        name: 'userManualCustomer',
        component: () => import('@/views/user/userManualCustomer/index'),
        meta: {
          title: '手动卡主',
        },
      },
      {
        path: 'userManualAppCustomer',
        name: 'userManualAppCustomer',
        component: () => import('@/views/user/userManualAppCustomer/index'),
        meta: {
          title: '手动 App 卡主',
        },
      },
      {
        path: 'userFinance',
        name: 'userFinance',
        component: () => import('@/views/user/userFinance/index'),
        meta: {
          title: '财务',
        },
      },
      {
        path: 'userSeller',
        name: 'userSeller',
        component: () => import('@/views/user/userSeller/index'),
        meta: {
          title: '商户',
        },
      },
      {
        path: 'userAdmin',
        name: 'userAdmin',
        component: () => import('@/views/user/userAdmin/index'),
        meta: {
          title: '管理员',
        },
      },
      {
        path: 'userOperator',
        name: 'userOperator',
        component: () => import('@/views/user/userOperator/index'),
        meta: {
          title: '操作员',
        },
      },
      {
        path: 'userSwitchboard',
        name: 'userSwitchboard',
        component: () => import('@/views/user/userSwitchboard/index'),
        meta: {
          title: '查单值机',
        },
      },
      {
        path: 'userOperatorAdmin',
        name: 'userOperatorAdmin',
        component: () => import('@/views/user/userOperatorAdmin/index'),
        meta: {
          title: '操作员管理员',
        },
      },
      {
        path: 'userKefu',
        name: 'userKefu',
        component: () => import('@/views/user/userKefu/index'),
        meta: {
          title: '客服',
        },
      },
      {
        path: 'userKefuAdmin',
        name: 'userKefuAdmin',
        component: () => import('@/views/user/userKefuAdmin/index'),
        meta: {
          title: '客服管理员',
        },
      },
      {
        path: 'fee',
        name: 'fee',
        component: () => import('@/views/user/fee/index'),
        meta: {
          title: '费率管理',
        },
      },
      {
        path: 'userCredentialAuditor',
        name: 'userCredentialAuditor',
        component: () => import('@/views/user/userCredentialAuditor/index'),
        meta: {
          title: '凭证审核员',
        },
      },
      {
        path: 'userSmsAdmin',
        name: 'userSmsAdmin',
        component: () => import('@/views/user/userSmsAdmin/index'),
        meta: {
          title: '短信模版管理员',
        },
      },
      {
        path: 'manualCustomer',
        name: 'manualCustomer',
        component: () => import('@/views/user/manualCustomer/index'),
        meta: {
          title: '纯手动卡主',
        },
      },
      {
        path: 'jifenReview',
        name: 'jifenReview',
        component: () => import('@/views/user/jifenReview/index'),
        meta: {
          title: '积分审核',
        },
      },
    ]
  },
  {
    name: 'finance',
    meta: {
      title: '提现管理',
    },
    path: '/finance',
    component: Layout,
    children: [
      {
        path: 'customerBankCard',
        name: 'customerBankCard',
        component: () => import('@/views/finance/customerBankCard/index'),
        meta: {
          title: '卡主银行卡筛选',
        },
      },
      {
        path: 'topupRecord',
        name: 'topupRecord',
        component: () => import('@/views/finance/topupRecord/index'),
        meta: {
          title: '充值记录管理',
        },
      },
      {
        path: 'financeCard',
        name: 'financeCard',
        component: () => import('@/views/finance/financeCard/index'),
        meta: {
          title: '财务卡管理',
        },
      },
    ]
  },
  {
    name: 'order',
    meta: {
      title: '订单管理',
    },
    path: '/order',
    component: Layout,
    children: [
      {
        path: 'orderCode',
        name: 'orderCode',
        component: () => import('@/views/order/orderPay/code'),
        meta: {
          title: '二维码订单管理',
        },
      },
      {
        path: 'orderPay',
        name: 'orderPay',
        component: () => import('@/views/order/orderPay/index'),
        meta: {
          title: '收款订单管理',
        },
      },
      {
        path: 'orderWithdraw',
        name: 'orderWithdraw',
        component: () => import('@/views/order/orderWithdraw/index'),
        meta: {
          title: '付款订单管理',
        },
      },
      {
        path: 'orderArbitrate',
        name: 'orderArbitrate',
        component: () => import('@/views/order/orderArbitrate/index'),
        meta: {
          title: '仲裁订单管理',
        },
      },
      {
        path: 'orderCheck',
        name: 'orderCheck',
        component: () => import('@/views/order/orderCheck/index'),
        meta: {
          title: '查单管理',
        },
      },
      {
        path: 'withdrawOrderReceiptOperate',
        name: 'withdrawOrderReceiptOperate',
        component: () => import('@/views/order/withdrawOrderReceiptOperate/index'),
        meta: {
          title: '提现订单管理',
        },
      },
      {
        path: 'orderReceiptCheck',
        name: 'orderReceiptCheck',
        component: () => import('@/views/order/orderReceiptCheck/index'),
        meta: {
          title: '出款审核',
        },
      },
      {
        path: 'payOrderReview',
        name: 'payOrderReview',
        component: () => import('@/views/order/payOrderReview/index'),
        meta: {
          title: '收款审核管理',
        },
      },
      {
        path: 'orderRealnameFeedback',
        name: 'orderRealnameFeedback',
        component: () => import('@/views/order/orderRealnameFeedback/index'),
        meta: {
          title: '实名反馈查询',
        },
      },
      {
        path: 'applyCheckArbitrate',
        name: 'applyCheckArbitrate',
        component: () => import('@/views/order/applyCheckArbitrate/index'),
        meta: {
          title: '申请查单仲裁',
        },
      },
    ]
  },
  {
    name: 'commission',
    meta: {
      title: '佣金管理',
    },
    path: '/commission',
    component: Layout,
    children: [
      {
        path: 'commissionPay',
        name: 'commissionPay',
        component: () => import('@/views/commission/commissionPay/index'),
        meta: {
          title: '收款佣金明细',
        },
      },
      {
        path: 'commissionWithdraw',
        name: 'commissionWithdraw',
        component: () => import('@/views/commission/commissionWithdraw/index'),
        meta: {
          title: '付款佣金明细',
        },
      },
    ]
  },
  {
    name: 'setting',
    meta: {
      title: '系统设置管理',
    },
    path: '/setting',
    component: Layout,
    children: [
      {
        path: 'groupAlert',
        name: 'groupAlert',
        component: () => import('@/views/setting/groupAlert/index'),
        meta: {
          title: '告警群通知',
        },
      },
      {
        path: 'general',
        name: 'general',
        component: () => import('@/views/setting/general/index'),
        meta: {
          title: '系统设置',
        },
      },
      {
        path: 'sysLog',
        name: 'sysLog',
        component: () => import('@/views/setting/sysLog/index'),
        meta: {
          title: '行为日志',
        },
      },
      {
        path: 'appLog',
        name: 'appLog',
        component: () => import('@/views/setting/appLog/index'),
        meta: {
          title: 'App操作日志',
        },
      },
      {
        path: 'jifenBalanceSnapshot',
        name: 'jifenBalanceSnapshot',
        component: () => import('@/views/setting/jifenBalanceSnapshot/index'),
        meta: {
          title: '跑量快照',
        },
      },
      {
        path: 'bulletin',
        name: 'bulletin',
        component: () => import('@/views/setting/bulletin/index'),
        meta: {
          title: '公告管理',
        },
      },
      {
        path: 'undeliveredMajorMessage',
        name: 'undeliveredMajorMessage',
        component: () => import('@/views/setting/undeliveredMajorMessage/index'),
        meta: {
          title: '群通知日志',
        },
      },
    ]
  },
  {
    name: 'certificate',
    meta: {
      title: '凭证管理',
    },
    path: '/certificate',
    component: Layout,
    children: [
      {
        path: 'certificateCode',
        name: 'certificateCode',
        component: () => import('@/views/certificate/code/index'),
        meta: {
          title: '二维码支付凭证',
        },
      },
      {
        path: 'certificatePay',
        name: 'certificatePay',
        component: () => import('@/views/certificate/certificatePay/index'),
        meta: {
          title: '支付订单凭证列表',
        },
      },
      {
        path: 'certificateWithdraw',
        name: 'certificateWithdraw',
        component: () => import('@/views/certificate/certificateWithdraw/index'),
        meta: {
          title: '提现订单凭证列表',
        },
      },
    ]
  },
  {
    name: 'statistics',
    meta: {
      title: '数据统计',
    },
    path: '/statistics',
    component: Layout,
    children: [
      {
        path: 'statisticsAgent',
        name: 'statisticsAgent',
        component: () => import('@/views/statistics/statisticsAgent/index'),
        meta: {
          title: '代理数据',
        },
      },
      {
        path: 'statisticsCommonAgent',
        name: 'statisticsCommonAgent',
        component: () => import('@/views/statistics/statisticsCommonAgent/index'),
        meta: {
          title: '通道型代理数据',
        },
      },
      {
        path: 'statisticsCustomer',
        name: 'statisticsCustomer',
        component: () => import('@/views/statistics/statisticsCustomer/index'),
        meta: {
          title: '卡主数据',
        },
      },
      {
        path: 'statisticsSeller',
        name: 'statisticsSeller',
        component: () => import('@/views/statistics/statisticsSeller/index'),
        meta: {
          title: '商户跑量',
        },
      },
      {
        path: 'statisticsOperator',
        name: 'statisticsOperator',
        component: () => import('@/views/statistics/statisticsOperator/index'),
        meta: {
          title: '操作员数据',
        },
      },
      {
        path: 'statisticsCredentialAuditor',
        name: 'statisticsCredentialAuditor',
        component: () => import('@/views/statistics/statisticsCredentialAuditor/index'),
        meta: {
          title: '审核员绩效数据',
        },
      },
      {
        path: 'statisticsBankCard',
        name: 'statisticsBankCard',
        component: () => import('@/views/statistics/statisticsBankCard/index'),
        meta: {
          title: '银行卡统计',
        },
      },
      {
        path: 'statisticsCode',
        name: 'statisticsCode',
        component: () => import('@/views/statistics/statisticsCode/index'),
        meta: {
          title: '二维码统计',
        },
      },
      {
        path: 'statisticsManual',
        name: 'statisticsManual',
        component: () => import('@/views/statistics/statisticsManual/index'),
        meta: {
          title: '人工跑量统计',
        },
      },
      {
        path: 'statisticsKefu',
        name: 'statisticsKefu',
        component: () => import('@/views/statistics/statisticsKefu/index'),
        meta: {
          title: '客服绩效数据',
        },
      },
    ]
  },
  {
    name: 'tactics',
    meta: {
      title: '派单策略管理',
    },
    path: '/tactics',
    component: Layout,
    children: [
      {
        name: 'tacticsManage',
        meta: {
          title: '派单策略管理',
        },
        path: 'tacticsManage',
        component: () => import('@/views/tactics/index'),
      },
    ]
  },
  {
    name: 'networkResourceManage',
    meta: {
      title: '网络资源管理',
    },
    path: '/networkResourceManage',
    component: Layout,
    children: [
      {
        path: 'smsResource',
        name: 'smsResource',
        component: () => import('@/views/networkResourceManage/smsResource/index'),
        meta: {
          title: '短信验证资源',
        },
      },
      {
        path: 'proxyPool',
        name: 'proxyPool',
        component: () => import('@/views/networkResourceManage/proxyPool/index'),
        meta: {
          title: '协议代理管理',
        },
      },
    ]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export default new Router({
  // mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})


// WEBPACK FOOTER //
// ./src/router/index.js